import { getCardEnableData, getFindPCPlink, getRXGuidlines, getsharingguidlineslink, updateNotificationStatus } from '../../ApiCall'
import { isVeraMember } from '../../VeraApiCall'

export const NavigateURL = (id, url, type) => {
  let cardName = ''
  let client_id = localStorage.getItem('CLIENT_ID')
  let obj = { notificationId: id }

  if (type == undefined) updateNotificationStatus(obj).then(res => {})
  if (url == 'Medical') {
    cardName = 'HealthQuestionnaire'
  }
  if (url == 'Needs' || url == 'MyNeeds') {
    cardName = 'MyNeeds'
  }
  if (url == 'Transaction' || url == "PAYMENT") {
    cardName = 'MyTransaction'
  }
  if (url == 'ProgramInformation') {
    cardName = 'ProgramInformation'
  }
  if (url == 'MemberIdcard' || url == 'DigitalHealthCardNew') {
    cardName = 'MembershipId'
  }
  if (url == 'HealthToolCard' || url == 'HealthToolsCard') {
    cardName = 'HealthTool'
  }
  if (url == 'DocumentsScreen') {
    cardName = 'Documents'
  }
  if (url == 'MobileTransaction') {
    cardName = 'ChangePayment'
  }
  if (url == 'HealthyLife') {
    cardName = 'HealthyLife'
  }
  if (url == 'PaymentWallet') {
    cardName = 'PaymentWallet'
  }
  if (url == 'notices') {
    cardName = 'notices'
  }
  if(url == 'Find_PCP'){
    cardName = 'notices'
  }
  if (url == 'RxGuideline') {
    cardName = 'RxGuideline'
  }

  getCardEnableData(client_id, cardName).then(res => {
    if (cardName == 'HealthTool') {
      if (res.data.response.enable == 'true' || res.data.response.enable == true) {
        window.location.href = '/HealthToolsCard'
      } else {
        localStorage.setItem('openModal', true)
        window.location.href = '/'
        // window.location.href ="/?openModal=true"
      }
    }

    if ((res && res.data.response.enable == 'false') || res.data.response.enable == false) {
      localStorage.setItem('openModal', true)
      window.location.href = '/'
    } else {
      if (cardName == 'HealthQuestionnaire') {
        window.location.href = '/MobileMedical'
      }
      if (cardName == 'MyNeeds') {
        window.location.href = '/MyNeedsMobile'
      }

      if (cardName == 'ProgramInformation') {
        window.location.href = '/ProgramInformation'
      }
      if (cardName == 'MembershipId') {
        window.location.href = '/DigitalHealthCardNew'
      }
      if (cardName == 'HealthyLife') {
        window.location.href = '/HealthyShareCard'
      }

      if (cardName == 'Documents') {
        window.location.href = '/DocumentsScreen'
      }
      if (cardName == 'MyTransaction') {
        // Vera (DISTRIBUTION PLATFORM) members have no payments page - notification click does nothing
        if (!isVeraMember()) window.location.href = '/MyTransactionMobile'
      }
      if (cardName == 'ChangePayment') {
        // Vera (DISTRIBUTION PLATFORM) members have no payments page - notification click does nothing
        if (!isVeraMember()) window.location.href = '/MobileTransaction'
      }
      if (cardName == 'PaymentWallet') {
        window.location.href = '/MyPaymentWalletMobile'
      }

      if (cardName == 'notices') {
       
        getsharingguidlineslink().then(res => {
          console.log('Sharing Guidlines', res)
          if (res.data && res.data.length > 0) {
            var windowReference = window.open()
            console.log('Shating guidlines response')
            let providerLink = res.data[0].fieldValue
            windowReference.location = providerLink
            // window.open('' + providerLink, '_blank')
          } else {
            console.log('Sharing guidlines else block')
            // alert('Data Not Availabe')
          }
        })
      }
      if (url == 'Find_PCP') {
               

        getFindPCPlink().then(res => {
          console.log('Sharing Guidlines', res)
          if (res.data && res.data.length > 0) {
            window.open(res.data[0].fieldValue);
            
                      } else {
            // alert('Data Not Availabe')
          }
        })
      }
      if (cardName == 'RxGuideline') {
       
        getRXGuidlines().then(res => {
          console.log('Sharing Guidlines', res)
          if (res.data && res.data.length > 0) {
            var windowReference = window.open()
            console.log('Shating guidlines response')
            let providerLink = res.data[0].fieldValue
            windowReference.location = providerLink
            // window.open('' + providerLink, '_blank')
          } else {
            console.log('Sharing guidlines else block')
            // alert('Data Not Availabe')
          }
        })
      }
    }
  })
}
